import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import NewsListStore from '@src/pages/news-list/store';
import Page from '../../components/page';
import InnerWrap from '../inner-wrap';
import Link from '@src/components/link';
import cx from 'classnames';
import DateUtil from '@src/utils/date-util';
import { Pagination } from 'antd';
import $$tracker from '@src/tracker';

const styles = require('./index.less');

const itemRender = (page, type, originalElement) => {
  if (type === 'prev') {
    return <a title="上一页">{'<'}</a>;
  }
  if (type === 'next') {
    return <a title="下一页">{'>'}</a>;
  }
  return originalElement;
};

const removeImgTags = html => {
  return html.replace(/<img\b[^>]*>/gi, '');
};

const NewsList = () => {
  const store = useStore(() => new NewsListStore());

  return (
    <Page className={styles.root}>
      <InnerWrap store={store.innerWrapStore}>
        <div className={styles.strategyHead}>
          <div className={styles.tabs}>
            {store.tabList.map((item, index) => (
              <Link
                className={cx(styles.tabItem, styles[`newTabItem${index}`], store.currentTab === index && styles.active)}
                key={index}
                onClick={() => {
                  $$tracker.clickJhkbNavInside(item.title || '');
                  store.setCurrentTab(index);
                }}
              >
                <span />
              </Link>
            ))}
          </div>
          {/* <div className={styles.search}>
            <input type="text" placeholder="搜索攻略资料" value={store.keyword} onChange={e => store.setKeyword(e.target.value)} />
            <Link className={styles.searchBtn} data-name="搜索按钮" />
          </div> */}
        </div>

        <div className={styles.strategyList}>
          {store.strategyList.map((item, index) => (
            <div
              className={styles.strategyItem}
              key={index}
              onClick={() => {
                $$tracker.clickJhkbDetailsInside(item.title || '');
                store.gotoDetail(item);
              }}
            >
              <div className={styles.strategyItemContent}>
                <div className={styles.date}>
                  <div className={styles.month}>{DateUtil.formatDate(new Date(item.published_at_show * 1000), 'MM')}</div>
                  <div className={styles.day}>{DateUtil.formatDate(new Date(item.published_at_show * 1000), 'dd')}</div>
                </div>
                <div className={styles.strategyItemInfo}>
                  <div className={styles.title}>{item.title}</div>
                  <div className={styles.desc} dangerouslySetInnerHTML={{ __html: removeImgTags(item.content || '') }} />
                </div>
                <Link className={styles.btnGoto} />
              </div>
            </div>
          ))}
          {store.strategyList.length === 0 && <div className={styles.noData}>暂无内容</div>}
        </div>

        <div className={cx(styles.pagination, (store.currentTab === 0 || store.strategyList.length === 0) && styles.hide)}>
          <Pagination
            total={store.total}
            current={store.currentPage}
            defaultPageSize={store.pageSize}
            size="small"
            showTotal={() => store.showTotal}
            itemRender={itemRender}
            onChange={page => store.changeCurrentPage(page)}
          />
          <div className={styles.quickJumper}>
            跳转至
            <input
              type="text"
              value={store.pageInput}
              onChange={e => {
                store.setPageInput(e.target.value);
              }}
            />
            页
            <Link
              className={styles.jumpBtn}
              onClick={() => {
                store.changeCurrentPage();
              }}
            />
          </div>
        </div>
      </InnerWrap>
    </Page>
  );
};

export default observer(NewsList);
